import { footerStyles } from "@insite/content-library/Pages/Footer";
import { subscribeStyles } from "@insite/content-library/Widgets/Basic/Subscribe";
import { footerContainerStyles } from "@insite/content-library/Widgets/Footer/FooterContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// Footer Page
footerStyles.page = {
    fullWidth: [false, false, false, false, false],
    css: css`
        padding: 0 0 15px 0;
        background-color: ${getColor("primary.main")};
        color: white;

        span:not(.icon-link-button) {
            color: white !important;
        }
    `,
};

// Footer Container
footerContainerStyles.widgetGridContainer = {
    isFullWidth: true,
    css: css`
        padding-top: 15px;
        max-width: 1700px;
        margin: 0 auto;
    `,
};

// Subscribe
subscribeStyles.emailButton = {
    variant: "tertiary",
};
